import React, { useState } from 'react'

import type {
  TAnalysisCalculationRowDto,
  TAnalysisResultDto
} from '@homepal/api-contract'

import { useTranslation } from 'language/translator'

import InfoButton from 'components_new/molecules/InfoButton'

import PotentialBreakdownDialog from 'components_new/organisms/dialogs/PotentialBreakdownDialog'

interface AnalysisCalculationProps {
  /** A selection's or one property's steps. */
  calculation: TAnalysisCalculationRowDto[]
  potential: number | null
  result: TAnalysisResultDto | null
}

/** Opens how the potential was reached, behind the same icon as a metric's. */
const AnalysisCalculation = (props: AnalysisCalculationProps) => {
  const { calculation, potential, result } = props

  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  if (calculation.length === 0 || potential === null) return null

  return (
    <>
      <InfoButton
        onClick={(e) => {
          e.stopPropagation()
          setOpen(true)
        }}
        onMouseDown={(e) => e.stopPropagation()}
        title={t('analyses', 'show_calculation')}
      />
      <PotentialBreakdownDialog
        calculation={calculation}
        onClose={() => setOpen(false)}
        open={open}
        potential={potential}
        result={result}
      />
    </>
  )
}

export default AnalysisCalculation
